import { useTutorial } from "../../context/tutorialContext";

function TutorialWelcome() {
    const { currentStep, next, skip, dismiss } = useTutorial();

    if (!currentStep) return null;

    const isCompletion = currentStep.isCompletion;

    return (
        <div className="ui-tutorial-welcome" role="dialog" aria-modal="true" aria-label={currentStep.title}>
            <div className="ui-tutorial-welcome__card">
                <h2 className="ui-tutorial-welcome__title">{currentStep.title}</h2>
                <p className="ui-tutorial-welcome__description">{currentStep.description}</p>

                {!isCompletion && (
                    <div className="ui-tutorial-welcome__actions">
                        <button
                            className="ui-tutorial-welcome__btn ui-tutorial-welcome__btn--primary"
                            onClick={next}
                        >
                            Start Tour
                        </button>
                        <button
                            className="ui-tutorial-welcome__btn ui-tutorial-welcome__btn--secondary"
                            onClick={dismiss}
                        >
                            Skip for Now
                        </button>
                        <button
                            className="ui-tutorial-welcome__btn ui-tutorial-welcome__btn--text"
                            onClick={skip}
                        >
                            Don't Show Again
                        </button>
                    </div>
                )}

                {isCompletion && (
                    <div className="ui-tutorial-welcome__actions">
                        <button
                            className="ui-tutorial-welcome__btn ui-tutorial-welcome__btn--primary"
                            onClick={next}
                        >
                            Go to Dashboard
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TutorialWelcome;
